import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import Home from "./components/pages/Home";
import Servico from "./components/pages/Servico";
import Blog from "./components/pages/Blog";
import Sobre from "./components/pages/Sobre";
import Projecto from "./components/pages/Projecto";
import Contacto from "./components/pages/Contacto";
import ServicoEspecifico from "./components/pages/ServicoEspecifico";
import Noticia from "./components/pages/Noticia";
import ScrollToTop from "./components/ScrollToTop";
import Termo from "./components/pages/Termo";
import Politica from "./components/pages/Politica";
import Faq from "./components/pages/Faq";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


 

 
 const App = () => {
  const [isDarkMode, setIsDarkMode] = useState(true);

  return (
    <>
      <Router>
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<Home isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>} />
          <Route path="/servicos" element={<Servico isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>} />
          <Route path="/blog" element={<Blog isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>} />
          <Route path="/sobre" element={<Sobre isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>} />
          <Route path="/projectos" element={<Projecto isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>} />
          <Route path="/contacto" element={<Contacto isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>} />
          <Route path="/servicos/:code" element={<ServicoEspecifico isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>} />
          <Route path="/blog/:code" element={<Noticia isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>} />
          <Route path="/termos" element={<Termo isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>} />
          <Route path="/politicas" element={<Politica isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>} />
          <Route path="/faq" element={<Faq isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode}/>} />
        </Routes>
      </Router>

      {/* 🔥 ToastContainer GLOBAL */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        toastStyle={{ borderRadius: 12 }}
      />
    </>
  );
};


export default App;

